<template>
    <div class="vrm-modal vrm-modal--wide mfp-with-anim">
        <div class="vrm-modal__header">
            <div class="vrm-modal__title">
                {{ $t('invite.invite_user', { i18nFallback: 'Invite a user' }) }}
            </div>
        </div>
        <form novalidate class="vrm-modal__content" name="inviteForm" @submit.prevent="onSubmit()">
            <vrm-text-field
                v-model="name"
                name="name"
                autocomplete="off"
                type="text"
                class="sg-element"
                :disabled="busy"
                :required="true"
                :title="$t('invite.name', { i18nFallback: 'Name' })"
            />
            <vrm-text-field
                v-model="email"
                name="email"
                autocomplete="off"
                type="email"
                class="sg-element"
                :disabled="busy"
                :required="true"
                :title="$t('invite.email', { i18nFallback: 'Email' })"
            />
            <div class="vrm-form__fieldset-item">
                <label class="sg-textfield-label">
                    <span class="sg-textfield-label-caption">
                        {{ $t('users.role', { i18nFallback: 'Role' }) }}:
                    </span>
                </label>
                <vrm-dropdown
                    v-model="accessLevelOption"
                    :options="userAccessLevelOptions"
                    :disabled="userAccessLevelOptions.length < 2 || busy"
                />
            </div>
            <div class="vrm-form__fieldset-item">
                <label class="sg-textfield-label">
                    <span class="sg-textfield-label-caption">
                        {{ $t('invite.personal_message', { i18nFallback: 'Personal message' }) }}
                    </span>
                </label>
                <textarea
                    v-model="note"
                    name="personal-message"
                    class="sg-element"
                    autocomplete="off"
                    :disabled="busy"
                />
            </div>
            <div class="row vrm-modal--share__content__control-row">
                <div class="col-xs-12">
                    <br />
                    <button type="submit" class="sg-btn sg-blue pull-right" :disabled="busy">
                        {{ $t('common.send', { i18nFallback: 'Send' }) }}
                    </button>
                </div>
            </div>
        </form>
        <modal-close-handle />
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';
import VrmDropdown from '@/vue/components/shared/VrmDropdown';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmTextField from '@/vue/components/forms/VrmTextField';
import { NOTIFICATION_TYPE_SUCCESS } from '@/vue/store/modules/notifications';

@Component({
    components: { VrmDropdown, VrmToggle, ModalCloseHandle, VrmTextField },
})
@AngularLocaleBundle('common')
@AngularLocaleBundle('invite')
@AngularLocaleBundle('users')
export default class InstallationUserInviteModal extends Vue {
    @Prop()
    idSite;
    @Prop()
    userAccessLevelOptions;

    @ngInject()
    ApiService;
    @ngInject()
    InstallationsService;
    @ngInject()
    vrmInstallationAccessLevel;
    @ngInject()
    vrmNotificationsService;

    name = '';
    email = '';
    note = '';
    busy = false;
    hasErrors = false;
    accessLevel = 0;

    get accessLevelOption() {
        return this.userAccessLevelOptions.find(option => option.accessLevel === this.accessLevel);
    }

    set accessLevelOption(option) {
        this.accessLevel = option.accessLevel;
    }

    async onSubmit() {
        if (this.busy || !this.validate()) return;
        this.busy = true;
        try {
            await this.ApiService.call2(`/installations/${this.idSite}/invite`, {
                personal_message: this.note,
                name: this.name,
                email: this.email,
                accessLevel: this.accessLevel,
            });
            this.vrmNotificationsService.add({
                type: NOTIFICATION_TYPE_SUCCESS,
                message: this.$t('users.invited_message'),
            });
            this.$emit('close');
        } finally {
            this.busy = false;
        }
    }

    validate() {
        this.hasErrors = false;
        this.validateChild(this);
        return !this.hasErrors;
    }

    validateChild(component) {
        if ('vrmValidate' in component) {
            const valid = component.vrmValidate();
            if (!valid) {
                this.hasErrors = true;
            }
        } else {
            component.$children.forEach(child => this.validateChild(child));
        }
    }
}
</script>
